"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../device"));
const User = __importStar(require("../../../../../user"));
const openapi_1 = require("../../../../openapi");
const Common = __importStar(require("../common"));
const Fleet = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Spec';
/*
 * `routes/v2/api/fleet/router.js` + `controllers/v2/fleet/index.js`
 *
 * Every route is guarded by `read` and the controller answers through
 * protocol v2 (typed `error.type`).
 */
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const KEYS_FORM = Common.ARRAY_QUERY_FORM('keys', 'brands', 'models');
const StatusQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Common.ModelCode), {
        exact: true,
    }).annotations({ description: 'One model code or repeated query parameter' }),
    brand: effect_1.Schema.optionalWith(Device.Vendor.Code, { exact: true }).annotations({
        description: 'Vendor code. Must be one of the brands visible to the caller.',
    }),
    status: effect_1.Schema.optionalWith(Common.ConnectionStatus, { exact: true }),
    customer: effect_1.Schema.optionalWith(User.Id, { exact: true }).annotations({
        description: 'Owner user id',
    }),
    tenantIds: effect_1.Schema.optionalWith(Common.TenantIds, { exact: true }),
});
const FiltersQuery = effect_1.Schema.Struct({
    keys: effect_1.Schema.optionalWith(effect_1.Schema.Array(Fleet.FilterKey), { exact: true }).annotations({
        description: 'Filter facets to retrieve; every facet when omitted. ' + KEYS_FORM,
    }),
});
const CustomerQuery = effect_1.Schema.Struct({
    customerId: User.Id,
});
const getStatus = platform_1.HttpApiEndpoint.get('getFleetStatus') ``
    .setUrlParams(StatusQuery)
    .addSuccess(openapi_1.Response.Success(Fleet.FleetDeviceList).annotations({
    description: 'Devices matching the filters',
}))
    .addError(openapi_1.Error.NotFound)
    .annotate(platform_1.OpenApi.Title, 'Fleet Status')
    .annotate(platform_1.OpenApi.Description, 'Returns every device of the fleet matching the filters, scoped to the tenants visible to the caller. ' +
    'Answers 404 when `customer` does not exist. ' +
    'Known runtime quirks: the controller always resolves the caller\u2019s brands, which requires an admin or brand role, so a caller with only `dealer` or `dealerTechnician` passes the guard but gets a typed 500 once the query and `customer` checks pass; ' +
    'a `brand` outside the caller\u2019s brands ends in a typed 500 and a device decoding failure in a v1 500 (the controller calls protocol helpers that do not exist); ' +
    'a query value that does not decode (for example `status=online`) is a v1 500, not the documented 400, because the error builder finds no status on the parse error.')
    .pipe(Common.withReadGuard, openapi_1.Error.withLegacyV2StandardErrors);
const getFilters = platform_1.HttpApiEndpoint.get('getFleetFilters') `/filters`
    .setUrlParams(FiltersQuery)
    .addSuccess(openapi_1.Response.Success(Fleet.FleetFilterList).annotations({
    description: 'Requested filter facets',
}))
    .addError(openapi_1.Error.NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Fleet Filters')
    .annotate(platform_1.OpenApi.Description, 'Returns the values available for the fleet filters, restricted to the brands and models visible to the caller. ' +
    'Answers 401 `NotAuthorizedError` when the caller may not read the fleet.')
    .pipe(Common.withReadGuard, openapi_1.Error.withLegacyV2StandardErrors);
const getCustomer = platform_1.HttpApiEndpoint.get('getFleetCustomer') `/customer`
    .setUrlParams(CustomerQuery)
    .addSuccess(openapi_1.Response.Success(Fleet.CustomerResponse).annotations({
    description: 'Customer information',
}))
    .addError(openapi_1.Error.NotFound)
    .annotate(platform_1.OpenApi.Title, 'Fleet Customer')
    .annotate(platform_1.OpenApi.Description, 'Returns the id and name of a customer (device owner). Answers 404 when no user has that id.')
    .pipe(Common.withReadGuard, openapi_1.Error.withLegacyV2StandardErrors);
const getConsumablesMetrics = platform_1.HttpApiEndpoint.get('getFleetConsumablesMetrics') `/consumables/metrics`
    .addSuccess(openapi_1.Response.Success(Fleet.ConsumableMetricsResponse).annotations({
    description: 'Fill-level distribution per consumable family',
}))
    .annotate(platform_1.OpenApi.Title, 'Fleet Consumables Metrics')
    .annotate(platform_1.OpenApi.Description, 'Returns the fill-level distribution of the fleet consumables per family. ' +
    'The repository currently serves a static sample; only the shape is stable.')
    .pipe(Common.withReadGuard, openapi_1.Error.withLegacyV2StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.fleet')
    .add(getStatus)
    .add(getFilters)
    .add(getCustomer)
    .add(getConsumablesMetrics)
    .prefix('/fleet')
    .annotate(platform_1.OpenApi.Title, 'Fleet')
    .annotate(platform_1.OpenApi.Description, 'Fleet overview: devices, filter facets, customers and consumables')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Fleet));
//# sourceMappingURL=spec.js.map